
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import AboutHero from './components/AboutHero';
import AboutStory from './components/AboutStory';
import MissionSection from './components/MissionSection';

const AboutPage = () => {
  return (
    <div className="min-h-screen bg-[#FDFBF7]">
      <Navbar />
      <AboutHero />
      <AboutStory />
      <MissionSection />
      <Footer />
    </div>
  );
};

export default AboutPage;
